export const USER = 2;
export const ADMIN = 1;
export const SUPER_ADMIN = 0;
export const ROLES: { [key: number]: string } = {
  0: "Owner",
  1: "Admin",
  2: "Lead",
  3: "Member"
};
